<template>
    <transition name="layout-fade">
        <loader v-if="loading"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Просмотр статистики для заказов</v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="closeLayout">
                    <v-icon>close</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <common :data-common="order"/>
                <platform :data-platform="order"/>
                <v-layout>
                    <v-flex xs5>
                        <customer :data-customer="order"/>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs5>
                        <delivery :data-delivery="order"/>
                    </v-flex>
                </v-layout>
                <payment :dataPayment="order"/>
                <v-flex xs12>
                    <v-layout>
                        <v-subheader class="headline pa-0 mt-5">Другое</v-subheader>
                    </v-layout>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Общая сумма всех заказов</v-subheader>
                            <b>{{ order.price_all | formatPrice }} сум</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Максимальная сумма за один заказ</v-subheader>
                            <b>{{ order.price_max | formatPrice }} сум</b>
                        </v-flex>
                    </v-layout>
                    <v-layout class="mt-3">
                        <v-flex xs5>
                            <v-subheader class="pa-0">Количество бонусов потраченных пользователями</v-subheader>
                            <b>{{ order.bonus_used | formatPrice }} баллов</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Итоговая стоимость заказов с вычетом бонусов</v-subheader>
                            <b>{{ order.price_real | formatPrice }} сум</b>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Statistic from '../../../api/statistic'
    import Loader from '../../../components/Loader/Layout'
    import Common from './Components/Order/Common'
    import Platform from './Components/Order/Platform'
    import Customer from './Components/Order/Customer'
    import Delivery from './Components/Order/Delivery'
    import Payment from './Components/Order/Payment'

    export default {
        name: 'statisticOrder',
        components: {
            Loader,
            Common,
            Platform,
            Customer,
            Delivery,
            Payment
        },
        data: () => ({
            loading: false,
            order: {
                all: 0,
                success: 0,
                failure: 0,
                in_progress: 0,
                mobile: 0,
                tg: 0,
                site: 0,
                customers_registered: 0,
                customers_unregistered: 0,
                payment_cash: 0,
                payment_no_cash: 0,
                payed_with_bonus: 0,
                payed_without_bonus: 0,
                delivery_self: 0,
                delivery_shipping: 0,
                price_all: 0,
                price_max: 0,
                bonus_used: 0,
                price_real: 0
            }
        }),
        created () {
            this.setHeaderTitle('Заказы')
        },
        mounted () {
            this.loading = true

            Statistic
                .getOrdersStat()
                .then(response => this.order = response.data.data)
                .catch(error => new Error(error))
                .finally(() => this.loading = false)
        },
        methods: {
            closeLayout () {
                this.$router.push({ name: 'headBlankIndex' })
            }
        }
    }
</script>
